import db from "../../../../api/mongodb";

export const fetchSafeAP=(setTableData, setLoading)=>{
    db.get('/api/safeAPs/public')
    .then((response)=>{
        setTableData(response.data)
        setLoading(false)
    })
    .catch((err)=>{
        setTableData([])
        setLoading(false)
    })
}

export const fetchSafeAPData=(id,setData, setLoading, navigate)=>{
    db.get(`/api/safeAPs/public/${id}`)
    .then((repsonse)=>{
        setData(repsonse.data)
        setLoading(false)
    })
    .catch((err)=>{
        setData({})
        setLoading(false)
        navigate("/directory")
    })
}